import { gql } from '@apollo/client';

export const GET_SINGLE_INSPECTION_INFO = gql`
  query GetSingleInspectionInfo($regionId: String!, $inspectionId: String!) {
    getSingleInspectionInfo(regionId: $regionId, inspectionId: $inspectionId) {
      basicInspectionFields {
        id
        apn
        inspectionTime
        submissionTime
        notes
        inspector
        issueSeverity
        attachments {
          id
          fileName
          link
        }
        propertyType
        inspectionType
        inspectionResult
        propertyAddress
        misc
      }
      ownerDetails {
        fullName
        primaryPhone
        email
      }
    }
  }
`;
